import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IRevenue } from 'src/app/shared/interfaces/revenue/irevenue';
import { saveRevenue } from 'src/app/store/revenue/revenue.actions';

@Component({
  selector: 'app-dados-receitas-form',
  templateUrl: './dados-receitas-form.component.html',
  styleUrls: ['./dados-receitas-form.component.scss'],
})
export class DadosReceitasFormComponent {
  form: FormGroup = this.fb.group({
    nameCategory: ['', Validators.required],
  });
  id: number = 0;
  clientId = localStorage.getItem('clientId')
  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private store: Store<IRevenue>,
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.item) {
      this.id = this.config.data.item.id;
      this.popularFormulario(this.config.data.item);
    }
  }

  popularFormulario(item: IRevenue) {
    this.form.controls['nameCategory'].setValue(item.nameCategory);
  }

  //functions
  saveForm() {
    const req: IRevenue = {
      nameCategory: this.form.value.nameCategory,
      client: `/api/clients/${this.clientId}`,
      status: true,
    };

    this.store.dispatch(saveRevenue({ revenue: req }));

    this.closeForm();
  }
  closeForm() {
    this.ref.close();
  }
}
